import React from "react";
import "./DesktopFilterModal.scss";
import PropTypes from 'prop-types';

import close from "../../../assets/imgs/icon-close.svg";

const DesktopFilterModal = ({
  handleClose,
  isVisible,
  modalLeft,
  modalBottom,
  isBubbleRight,
  children,
  ...props
}) => (
  <div
    className="desktop-filter-modal"
    style={{ display: isVisible ? 'block' : 'none', left: modalLeft, bottom: modalBottom }}
    { ...props }
  >
    <img
      className="desktop-filter-modal__close"
      src={close}
      alt="close"
      onClick={() => handleClose()}
    />
    {children}
    <div className={`desktop-filter-modal__bubble_corner ${isBubbleRight ? 'desktop-filter-modal__bubble_corner--right' : ''}`} />
  </div>
);

DesktopFilterModal.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func,
  isBubbleRight: PropTypes.bool,
  isVisible: PropTypes.bool,
  modalLeft: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  modalBottom: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
}

DesktopFilterModal.defaultProps = {
  children: null,
  handleClose: () => {},
  isBubbleRight: false,
  isVisible: false,
  modalBottom: 150,
  modalLeft: 0,
}

export default DesktopFilterModal;
